import React, { useState } from "react";
import { Accordion, Modal } from "react-bootstrap";
import { IDMCActivityWTourOptions } from "commonFnBcode/types/dmc.types";
import ActivityInfoSection from "./ActivityInfoSection";
import ActivityDescriptionSection from "./ActivityDescriptionSection";
import DragActivityItem from "./DragActivityItem";

interface ActivityEditFormProps {
  show: boolean;
  onHide: () => void;
  activity: IDMCActivityWTourOptions | null;
}

function ActivityEditForm({ show, onHide, activity }: ActivityEditFormProps) {
  const [description, setDescription] = useState("");
  const [enhancedDescription, setEnhancedDescription] = useState("");
  const [currentActivity, setCurrentActivity] =
    useState<IDMCActivityWTourOptions | null>(null);

  React.useEffect(() => {
    if (activity) {
      setDescription(activity.description || "");
      //   setEnhancedDescription(activity.enhancedDescription || "");
      setCurrentActivity(activity);
    }
  }, [activity]);

  if (!currentActivity) return null;

  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-edit me-2"></i>
          Edit Activity: {currentActivity.name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{ maxHeight: "88vh", overflowY: "auto" }}
        className="p-4"
      >
        <ActivityInfoSection activity={currentActivity} />

        <Accordion defaultActiveKey="1">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              {" "}
              <h5 className="text-primary">
                <i className="fas fa-edit me-2"></i>
                Description Management
              </h5>
            </Accordion.Header>
            <Accordion.Body>
              <ActivityDescriptionSection
                description={description}
                enhancedDescription={enhancedDescription}
                onDescriptionChange={setDescription}
                onEnhancedDescriptionChange={setEnhancedDescription}
                activity={currentActivity}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <h5 className="text-primary pb-2">
                <i className="fas fa-images me-2"></i>
                Tour Option Images
              </h5>
            </Accordion.Header>
            <Accordion.Body>
              <DragActivityItem tourOptions={currentActivity.tourOptions} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Modal.Body>
    </Modal>
  );
}

export default ActivityEditForm;
